import React, { useState } from "react";
import {
  decrypt,
  encrypt,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import AuthBg from "./AuthBg";
import * as Yup from "yup";
import { useFormik } from "formik";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import ClipLoader from "react-spinners/ClipLoader";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { ToastContainer } from "react-toastify";
import { getCookie, setCookie } from "../../helpers/CookieComponent";
import OTPInput from "react-otp-input";

const onlyIntRegExp = /^[0-9+]+$/;
const onlyAlphabet = /^[A-Za-z][A-Za-z\s]+$/;

// Formik InitialValues
const initialValues = {
  otp: "",
};

// Fromik Validation Schema
const schema = Yup.object().shape({
  otp: Yup.string()
    .matches(/^\d{6}$/, "OTP is invalid")
    .required("OTP is required"),
});

const EmailOtpVerify = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { userId, userName } = location.state || "";

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        userId: userId,
        otp: values.otp,
      };

      const response = await postData(
        "user/email/otp/verify",
        param,
        apiHeader(false)
      );
      console.log(response);

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          navigate("/registerconfirm", {
            state: {
              userName: userName,
            },
          });
          resetForm();
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  const handleOtpChange = (value) => {
    formik.setFieldValue("otp", value);
  };

  return (
    <>
      <ToastContainer />
      <div className="flex flex-col lg:flex-row lg:justify-end lg:min-h-[85vh] xl:min-h-screen h-max">
        {/* Background Section */}
        <div className="h-auto lg:h-screen z-[1] relative lg:fixed top-0 left-0 lg:w-[40%]">
          <AuthBg />
        </div>
        <div className="lg:w-[60%] py-[5%] px-[5%] md:px-[10%] bg-yellow">
          <div className="flex flex-col lg:flex-row w-full p-10">
            <div className="flex items-center justify-center flex-col lg:flex-row w-full">
              <div className="w-full lg:w-[500px]">
                <h1 className="mb-4 auth-title-y">Verify OTP</h1>
                <p className="mb-[10rem] auth-text-g">
                  OTP sent to your registered email address
                </p>
                <form onSubmit={formik.handleSubmit}>
                  <div className="w-full flex flex-col gap-[2rem] mb-[15rem] lg:mb-[15rem]">
                    <OTPInput
                      value={formik.values.otp}
                      onChange={handleOtpChange}
                      numInputs={6}
                      inputType="number"
                      renderInput={(props) => <input {...props} />}
                      shouldAutoFocus={true}
                      inputStyle={{
                        justifyContent: "space-around",
                        border: "1px solid rgba(0,0,0,0.3)",
                        borderRadius: "8px",
                        width: "50px",
                        height: "50px",
                        fontSize: "1.5rem",
                        margin: "auto auto auto 0",
                        color: "#000",
                        fontWeight: "400",
                        caretColor: "blue",
                      }}
                    />
                    {formik.touched.otp && formik.errors.otp && (
                      <div className="mt-2 error-msg">
                        <div className="">{formik.errors.otp}</div>
                      </div>
                    )}
                  </div>
                  <div className="w-full justify-center lg:justify-start gap-5 flex">
                    <button
                      type="submit"
                      className="btn-auth"
                      disabled={loading}
                    >
                      {!loading && <>Verify OTP</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailOtpVerify;
